import { useState, useEffect, KeyboardEventHandler } from 'react';
import { useStore } from '@ui/hooks/useStore';
import useKeyDown from '@ui/hooks/useKeyDown';
import { IState } from './IState';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const useDeviceDelete = (onClose: ICloseEvent['onClose']) => {
    const { devices, groups, app, lang } = useStore();
    const key = useKeyDown();
    const imei = devices.selectedDeviceImei;
    const [device] = devices.deviceList.filter((d) => d.imei === imei);

    const initState: IState = {
        deviceName: device?.name ?? '',
    };
    const [state, setState] = useState(initState);

    const handleConfirmClick = () => {
        if (!app.demoMode) {
            devices.resetServerError();
            app.closeDeviceSettings();
            app.closeDeviceEdit();
            app.closeDeviceInfo();
            devices.resetSettingDeviceImei();
            devices.resetEditedDeviceImei();
            devices.resetInfoDeviceImei();
            devices.deleteDevice();
        } else app.setDemoModeError();
    };
    const handleKey = (key: string) => {
        switch (key) {
            case 'Escape':
                onClose();
                break;
            case 'Enter':
                handleConfirmClick();
                break;
        }
    };
    const handleBtnKeyDown: KeyboardEventHandler<HTMLElement> = (e) => {
        const { key } = e;
        if (key === 'Enter') {
            e.stopPropagation();
            e.preventDefault();
            const target = e.target as HTMLElement;
            target.click();
        }
    };
    const handlers = {
        handleConfirmClick,
        handleBtnKeyDown,
    };

    useEffect(() => {
        devices.resetServerError();
        app.resetDemoModeError();
        const element = document.activeElement as HTMLElement;
        if (devices.operationSuccess) {
            devices.resetOperationSuccess();
        }
        if (element) {
            element.blur();
        }
    }, []);
    useEffect(() => {
        if (devices.operationSuccess) {
            onClose();
            devices.resetOperationSuccess();
        }
    }, [devices.operationSuccess]);
    useEffect(() => {
        handleKey(key);
    }, [key]);
    useEffect(() => {
        if (!device) onClose();
    }, [device]);

    return {
        groups,
        devices,
        app,
        lang,
        state,
        handlers,
    };
};

export default useDeviceDelete;
